<template>
  <div id="reco-passenger-page">
    <RecoPassenger />
  </div>
</template>

<script>
import RecoPassenger from '../components/RecoPassenger.vue'

export default {
  name: 'RecoPassengerPage',
  components: {
    RecoPassenger
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/pages/RecoPassenger.vue